import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="venue-field"
export default class extends Controller {
  static targets = ["frame", "value"];
  connect() {}

  update() {
    const baseUrl = this.frameTarget.dataset.url;
    const params = new URLSearchParams();
    const venue = JSON.parse(this.valueTarget.value);
    if (venue) {
      // Add venue properties to the search params
      if (venue.displayName) params.append("venue[name]", venue.displayName);
      if (venue.formattedAddress)
        params.append("venue[address]", venue.formattedAddress);
      if (venue.lat) params.append("venue[lat]", venue.lat);
      if (venue.lng) params.append("venue[lng]", venue.lng);
      if (venue.id) params.append("venue[place_id]", venue.id);
      if (venue.addressComponents)
        params.append(
          "venue[address_components]",
          JSON.stringify(venue.addressComponents),
        );
    }
    // Check if baseUrl already has a query string
    const separator = baseUrl.includes("?") ? "&" : "?";
    this.frameTarget.src = `${baseUrl}${separator}${params.toString()}`;
  }
}
